import { useAppSelector } from "../../store/reducer";
import { redirectTilHelsenorgeElement } from "../../utils/urlUtils";

import AnchorLink from "@helsenorge/designsystem-react/components/AnchorLink";

import styles from "../../styles/oppgave-detaljer.module.scss";

import {
  getReferanseLabelTekst,
  getReferanseLenkeTekst,
} from "../../utils/elementReferansehjelper";
import { useGetResources } from "../../hooks/useGetResources";

export const ReferanserComp = (): React.JSX.Element | null => {
  const resources = useGetResources();
  const oppgave = useAppSelector((state) => state.oppgaveDetaljer.oppgave);

  if (!oppgave || !oppgave.Referanser || oppgave.Referanser.length === 0) {
    return null;
  }

  return (
    <>
      {oppgave.Referanser.map(
        (element) =>
          element.Id && (
            <div
              className={`${styles.detaljer_seksjon} ${styles.tekstblokk}`}
              key={`${element.Type}_${element.Id}`}
            >
              <div>{getReferanseLabelTekst(element, resources)}</div>
              <div>
                <AnchorLink
                  href={redirectTilHelsenorgeElement(element)}
                  testId={`${element.Type}_${element.Id}`}
                  aria-label="lenke"
                >
                  {getReferanseLenkeTekst(element, resources)}
                </AnchorLink>
              </div>
            </div>
          ),
      )}
    </>
  );
};
